import { useEffect, useState } from 'react';
import { useClassWrapper } from '_helpers';
import { ROLES } from '../_helpers/roles';
import { Card } from 'antd';
import { useAttendanceActions } from '_actions/attendance.actions';
import { HomeworkChart } from '_components/dashboard';
import { StudentScore } from '_components/studentScoreList';

export { StuHome };

function StuHome() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const classWrapper = useClassWrapper();
    const attendanceActions = useAttendanceActions();
    const classId = classWrapper.curClass?.class_id;
    const curClassName = classWrapper.curClass?.class_name;

    // Lessons left in THIS class = total sessions − sessions the teacher marked "đã học".
    // (Class attendance lessons, NOT the student's tuition package quota.)
    const [lessons, setLessons] = useState({ total: 0, held: 0 });
    useEffect(() => {
        let alive = true;
        if (!classId) return;
        attendanceActions.getSessions(classId).then(arr => {
            if (!alive) return;
            const sessions = Array.isArray(arr) ? arr : [];
            setLessons({ total: sessions.length, held: sessions.filter(s => s.held).length });
        });
        return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classId]);

    const left = Math.max(0, lessons.total - lessons.held);

    if (userData.role !== ROLES.STUDENT) return null;

    return (
        <div className="p-4">
            <div className="container page-enter">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
                    <div>
                        <h2 style={{ margin: 0 }}>Chào {userData?.name || 'bạn'}</h2>
                        {curClassName && <div style={{ color: 'var(--ink-4)' }}>{curClassName}</div>}
                    </div>
                    {classId && (
                        <Card size="small" style={{ borderColor: '#52B6CE' }} bodyStyle={{ padding: '10px 16px' }}>
                            <div style={{ fontSize: 12, color: 'var(--ink-4)' }}>Số buổi còn lại</div>
                            <div style={{ fontSize: 22, fontWeight: 700, color: '#52B6CE' }}>
                                {left}/{lessons.total} <span style={{ fontSize: 13, fontWeight: 400, color: 'var(--ink-4)' }}>buổi</span>
                            </div>
                        </Card>
                    )}
                </div>

                {classId && <HomeworkChart classId={classId} />}

                <div style={{ marginTop: 16 }}>
                    <StudentScore isPersonal={true} />
                </div>
            </div>
        </div>
    );
}
